import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  cardMainParent: {
    float: "left",
    width: "100%",
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  tabCardContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "none",
    borderRadius: "0px",
    padding: theme.spacing(2),
  },
  UserMainPanel: {
    width: "100%",
  },
  formRow: {
    width: "100%",
  },
  inlineHeading: {
    fontWeight: "bold",
    fontSize: "15px",
  },
  dateTime: { width: "100%", "& .MuiOutlinedInput-input": { padding: "10px" } },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  sectionHeading: {
    marginTop: "10px",
    marginBottom: "10px",
    "& .MuiTypography-root": { fontWeight: "bold", fontSize: "15px" },
  },
  hideDatesGrid: {
    display: "none",
  },
  filterDateField: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      height: "40px",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 14px",
    },
  },
  filterDateFieldWrapper: {
    position: "relative",
    width: "100%",
    "& .flatpickr-outer": {
      position: "absolute !important",
      top: "9px !important",
      left: "0 !important",
      right: "0 !important",
      bottom: "auto !important",
      marginLeft: "5px !important",
      "& input": {
        padding: "10px 14px !important",
        height: "22px !important",
        boxSizing: "border-box",
        fontSize: "13px !important",
        lineHeight: "22px !important",
        border: "none !important",
        background: "transparent !important",
        width: "calc(100% - 10px) !important",
      },
    },
  },
  filterRow: {
    alignItems: "flex-end",
  },
  modeSwitchRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  modeSwitchLabel: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
    color: "#000",
  },
}));
